'use client';
import './FilterControls.css';

const FilterControls = ({ filters, onFilterChange }) => {
  const handleInputChange = (field, value) => {
    onFilterChange({
      ...filters,
      [field]: value,
    });
  };

  const clearFilters = () => {
    onFilterChange({
      case: '',
      status: '',
      startDate: '',
      endDate: '',
      client_url: '',
    });
  };

  return (
    <div className="filter-controls">
      <h3>Filter Options</h3>
      <div className="filter-row">
        <div className="filter-group">
          <label>Case:</label>
          <select value={filters.case} onChange={e => handleInputChange('case', e.target.value)}>
            <option value="">All Cases</option>
            <option value="openai">OpenAI</option>
            <option value="python">Python</option>
            <option value="motive">Motive</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={filters.status}
            onChange={e => handleInputChange('status', e.target.value)}
          >
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="success">Success</option>
            <option value="error">Error</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Start Date:</label>
          <input
            type="date"
            value={filters.startDate}
            onChange={e => handleInputChange('startDate', e.target.value)}
          />
        </div>

        <div className="filter-group">
          <label>End Date:</label>
          <input
            type="date"
            value={filters.endDate}
            onChange={e => handleInputChange('endDate', e.target.value)}
          />
        </div>
        <div className="filter-group">
          <label>ClientURL</label>
          <input
            type="text"
            value={filters.client_url}
            onChange={e => handleInputChange('client_url', e.target.value)}
          />
        </div>

        <button onClick={clearFilters} className="clear-btn">
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default FilterControls;
